<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">添加</el-button>
    <el-dialog
      :visible="dialogVisible"
      title="添加Banner"
      width="1000px"
      @close="closeDialog"
    >
      <el-form :model="bannerDetail" ref="bannerForm" class="banner-form" :rules="rules" label-width="200px">
        <!-- <el-form-item label="广告位置：" prop="type">
          <el-select v-model="bannerDetail.type" placeholder="请选择">
            <el-option
              v-for="item in positionTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
<!--        <el-form-item label="key：" prop="key">-->
<!--          <el-input v-model="bannerDetail.key"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="标题：" prop="title">
          <el-input v-model="bannerDetail.title"></el-input>
        </el-form-item>
        <el-form-item label="描述：" prop="descriptions">
          <el-input type="textarea"
                    style="resize:none;"
                    :rows="5"

                    v-model="bannerDetail.descriptions"></el-input>
        </el-form-item>
        <el-form-item label="文件：" prop="imageUrl">
          <upload v-model="bannerDetail.imageUrl" :data="uploadData"></upload>
          <p class="size-tip">{{query.type | imgSize}}</p>
        </el-form-item>
        <el-form-item label="跳转地址：" prop="linkUrl">
          <el-input v-model="bannerDetail.linkUrl"></el-input>
        </el-form-item>
        <el-form-item label="活动：" prop="actType">
          <el-select v-model="bannerDetail.actType" placeholder="活动名称">
            <el-option label="无" value="0"></el-option>
            <el-option label="七折抢购" value="1"></el-option>
            <el-option label="交易挖矿" value="2"></el-option>
            <el-option label="随机免单" value="3"></el-option>
            <el-option label="hash夺宝" value="4"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('bannerForm')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Upload from 'components/upload';
import {SIZE_TIPS} from '../../constants.js';

export default {
  name: 'CreateBanner',
  props: ['value'],
  data() {
    return {
      dialogVisible: false,
      bannerDetail: {},
      rules: {
        title: [{ required: true, message: '标题不能为空！' }],
        imageUrl: [{ required: true, message: '文件不能为空！' }]
      }
    };
  },
  components: {
    Upload
  },
  computed: {
    ...mapState('BannerNewSetting', [
      'positionTypeList',
      'platformTypeList',
      'languageList',
      'query',
      'uploadData'
    ]),
    ...mapGetters('BannerNewSetting', ['bannerList'])
  },
  methods: {
    ...mapActions('BannerNewSetting', ['create', 'list']),
    closeDialog() {
      this.dialogVisible = false;
      this.bannerDetail = {};
      this.$refs['bannerForm'].resetFields();
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.create({ ...this.query, ...this.bannerDetail }).then(() => {
            this.$message({
              message: '添加成功！',
              type: 'success'
            });
            this.dialogVisible = false;
            this.$emit('refresh');
          });
        }
      });
    }
  },
  filters: {
    imgSize(val) {
      return SIZE_TIPS['s' + parseInt(val)] && ('图片尺寸：' + SIZE_TIPS['s' + parseInt(val)]) || ' ';
    }
  }
};
</script>

<style lang="less" scoped>
.banner-form {
  margin-right: 100px;
}
</style>
